import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/stores/authStore';
import axios from 'axios';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();

  const onFinish = async (values) => {
    setLoading(true);
    
    try {
      const response = await axios.post('/api/auth/login', {
        credential: values.username,
        password: values.password
      });

      if (response.data.success) {
        const { user, token, refreshToken } = response.data.data;
        
        // 儲存到狀態管理
        login(user, token, refreshToken);
        
        // 儲存到 localStorage
        if (values.remember) {
          localStorage.setItem('token', token);
          localStorage.setItem('refreshToken', refreshToken);
        }

        message.success('登入成功！');
        navigate('/');
      }
    } catch (error) {
      message.error(error.response?.data?.error || '登入失敗，請檢查帳號密碼');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Card
        style={{
          width: 400,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 28, fontWeight: 'bold', color: '#1890ff' }}>
            報價系統
          </h1>
          <p style={{ color: '#999' }}>經銷商訂單報價管理</p>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '請輸入使用者名稱或 Email' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="使用者名稱或 Email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '請輸入密碼' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密碼"
            />
          </Form.Item>

          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>記住我</Checkbox>
            </Form.Item>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
            >
              登入
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
          <p>預設帳號: admin / Admin@123</p>
        </div>
      </Card>
    </div>
  );
};

export default Login;
